import { render, staticRenderFns } from "./ModifyUserDocs.vue?vue&type=template&id=5e8e5ea7&"
import script from "./ModifyUserDocs.vue?vue&type=script&lang=ts&"
export * from "./ModifyUserDocs.vue?vue&type=script&lang=ts&"
import style0 from "./ModifyUserDocs.vue?vue&type=style&index=0&id=5e8e5ea7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports